import { render, staticRenderFns } from "./championships.vue?vue&type=template&id=38112d6b&scoped=true"
import script from "./championships.vue?vue&type=script&lang=js"
export * from "./championships.vue?vue&type=script&lang=js"
import style0 from "./championships.vue?vue&type=style&index=0&id=38112d6b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38112d6b",
  null
  
)

export default component.exports